import { motion } from "framer-motion";

const dotColors = ["#7dd3fc", "#00d4ff", "#a855f7", "#7dd3fc"];

export default function TimelineItem({ experience, index }) {
  const isLeft = experience.side === "left";

  return (
    <div className="relative flex items-center">
      {/* Dot on center line (desktop) */}
      <div
        className="absolute left-1/2 w-4 h-4 rounded-full border-2 border-terminal transform -translate-x-1/2 hidden md:block z-10"
        style={{
          backgroundColor: dotColors[index % dotColors.length],
          boxShadow: `0 0 12px ${dotColors[index % dotColors.length]}80`,
        }}
      />
      {/* Dot on left line (mobile) */}
      <div
        className="absolute left-4 w-4 h-4 rounded-full border-2 border-terminal transform -translate-x-1/2 md:hidden z-10"
        style={{
          backgroundColor: dotColors[index % dotColors.length],
          boxShadow: `0 0 12px ${dotColors[index % dotColors.length]}80`,
        }}
      />

      {/* Desktop layout: alternating */}
      <div className="hidden md:flex w-full">
        {isLeft ? (
          <>
            <motion.div
              initial={{ opacity: 0, x: -60 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="w-1/2 pr-12 text-right"
            >
              <Card experience={experience} />
            </motion.div>
            <div className="w-1/2" />
          </>
        ) : (
          <>
            <div className="w-1/2" />
            <motion.div
              initial={{ opacity: 0, x: 60 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{ duration: 0.5, delay: 0.1 }}
              className="w-1/2 pl-12"
            >
              <Card experience={experience} />
            </motion.div>
          </>
        )}
      </div>

      {/* Mobile layout: all on right of line */}
      <motion.div
        initial={{ opacity: 0, x: -30 }}
        whileInView={{ opacity: 1, x: 0 }}
        viewport={{ once: true, margin: "-30px" }}
        transition={{ duration: 0.4 }}
        className="md:hidden ml-10"
      >
        <Card experience={experience} />
      </motion.div>
    </div>
  );
}

function Card({ experience }) {
  return (
    <div className="bg-terminalLight rounded-xl p-6 border border-terminalBorder hover:border-accentBlue/30 transition-colors">
      <h3 className="text-xl font-semibold text-brightText">
        {experience.title}
      </h3>
      <p className="text-dimText text-sm mt-1">{experience.organization}</p>
      <p className="text-accentBlue text-xs font-mono font-medium mt-2">
        {experience.date}
      </p>
    </div>
  );
}
